import { SceneNames } from '@Core/SceneNames';
import { EGameEvents } from '@Managers/Events/GameEvents';
import { LoggerLevel, LoggerSource } from './LoggerLevel';

export enum LoggerTarget {
    CONSOLE = 'console',
    KIBANA = 'kibana'
}

export type TLoggerParameters = {
    source: LoggerSource;
    sourceName?: string;
    component?: string;
    class?: SceneNames | string;
    fn?: string;
    message?: string;
    data?: string | object | undefined;
    separator?: boolean;
    label?: string;
};

export type TLoggerState = {
    levels: Record<LoggerLevel, TLoggerStateItem>;
    sources: Record<LoggerSource, TLoggerStateItem>;
};

export type TLoggerStateItem = {
    console: boolean;
    kibana: boolean;
};

export type DeviceRegexRule = { regex: RegExp; type: DeviceType; vendor?: Vendor; model?: DeviceModel | string; modelGroup?: number };
export type OSRegexRule = { regex: RegExp; name: OSName; versionGroup?: number };
export type BrowserRegexRule = { regex: RegExp; name: BrowserName; versionGroup?: number };
export type EngineRegexRule = { regex: RegExp; name: EngineName; versionGroup?: number };

export enum OSName {
    Windows = 'Windows',
    Android = 'Android',
    iOS = 'iOS',
    macOS = 'macOS',
    Linux = 'Linux'
}

export enum BrowserName {
    Firefox = 'Firefox',
    Chrome = 'Chrome',
    Safari = 'Safari',
    Edge = 'Edge',
    Opera = 'Opera'
}

export enum EngineName {
    WebKit = 'WebKit',
    Gecko = 'Gecko',
    Trident = 'Trident',
    Blink = 'Blink'
}

export enum DeviceType {
    Mobile = 'mobile',
    Tablet = 'tablet',
    Desktop = 'desktop'
}

export enum Vendor {
    Apple = 'Apple',
    Samsung = 'Samsung',
    Google = 'Google',
    Motorola = 'Motorola',
    Huawei = 'Huawei',
    Xiaomi = 'Xiaomi'
}

export enum DeviceModel {
    iPhone = 'iPhone',
    iPad = 'iPad'
}

export interface IWaitForEventTimestampOptions<T> {
    event: EGameEvents;
    eventIds?: number[];
    validator?: (data: T) => boolean;
}
